export const newUserPredicate = (u: MfsUser) => u.invitedDate == undefined && u.emailConfirmedDate == undefined;
export const unconfirmedUserPredicate = (u: MfsUser) => u.invitedDate != undefined && u.emailConfirmedDate == undefined;
export const liveUserPredicate = (u: MfsUser) => u.invitedDate != undefined && u.emailConfirmedDate != undefined;

export class MfsUser {
  id: string;
  mfsUserId: number;
  email: string;
  role: string; // the role name
  roleId: string;
  linkedBy: string; // description of link
  linkedTo: string;
  withAccessTo: string;
  limitedAccessConfig: MfsLimitedAccessConfig;
  status: string;
  createdDate: Date;
  invitedDate: Date;
  emailConfirmedDate: Date;

  public constructor(init?: Partial<MfsUser>) {
    Object.assign(this, init);
  }
}


export class MfsLimitedAccessConfig {
  limitedAccessConfigType: number;
  limitedAccessCreditorUris: number[] = [];
  limitedAccessSupplierRef: number;
}


export type MfsUserFilter =
  | 'All'
  | 'New'
  | 'Unconfirmed'
  | 'Live'
  ;

export interface MfsUserCounts {
  All: number;
  New: number;
  Unconfirmed: number;
  Live: number;
}
